import { CircularProgress } from '@mui/material';
import { useAuth } from 'context/auth';
import { useRoleCapabilities } from 'hooks/useRoleCapabilities';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PATH from 'crono-fe-common/constants/path';

const SubscriptionPageInterceptor = () => {
  const { user } = useAuth();
  const { canManageSubscription } = useRoleCapabilities();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    //Only subscription manager can access the subscription page
    if (!canManageSubscription) {
      navigate(PATH.HOME);
      return;
    }
    navigate(PATH.SETTINGS.SUBSCRIPTION);
  }, [user, canManageSubscription]);
  return (
    <>
      <FlexDiv>
        <CircularProgress />
      </FlexDiv>
    </>
  );
};

export default SubscriptionPageInterceptor;
